<template>
	<div>
		<LightboxBase class="adblock" :close="close">
			<div class="adblock__content">
				<h2>Vypněte si AdBlock, prosím!</h2>
				<div style="width:100%;height:0;padding-bottom:45%;position:relative;">
					<iframe src="https://giphy.com/embed/3ohzdYjwEQuR1J7dte?video=0" width="100%" height="100%" style="position:absolute" frameBorder="0" class="giphy-embed" allowFullScreen></iframe>
				</div>
				<p class="giphy"><a href="https://giphy.com/gifs/alien-sigourney-weaver-ripley-3ohzdYjwEQuR1J7dte">via GIPHY</a></p>
				<p>
					ArtKina pro vás děláme zcela zdarma ve volném čase.<br>
					Reklamy nám přináší alespoň pár korun, které nám pomáhají získávat motivaci v ArtKinech pokračovat.<br>
					Budeme rádi, když si AdBlock vypnete a přispějete nám tím třeba na pivo.<br>
					Děkujeme!
				</p>
			</div>
		</LightboxBase>
	</div>
</template>

<script>
import LightboxBase from './LightboxBase.vue'
import * as moment from 'moment'

export default {
	components: { LightboxBase },
	methods: {
		close () {
			document.querySelector('html').classList.remove('lightbox--active', 'lightbox--active-adblock')
			if (typeof localStorage !== 'undefined') {
				localStorage.setItem('adblock', moment().add(1, 'day').unix())
			}
		}
	}
}
</script>

<style lang=less>
	@import "../../assets/less/default.less";

	html.lightbox--active.lightbox--active-adblock {
		#lightbox.adblock { max-width: 100%; max-height: 100%; }
	}
	#lightbox.adblock {
		.lightbox {
			&__content { max-width: 60vw; height: 80vh;
				@media @tablet {
					max-width: 80vw;
				}
				@media @mobile {
					max-width: 90vw;
				}
			}
		}
		.lightbox__wrapper--inner { display: flex; }
		.adblock__content { width: 80%; display: block; margin: auto;
			h2 { margin-bottom: 0.5rem; color: @red; font-size: 2rem; text-align: center; }
			p { margin: 0.5rem 0; font-size: 1.1rem; }
			.giphy { text-align: right;
				a { color: white; font-size: 0.8rem; }
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/lightbox/LightboxAdblock.vue